// extracted by mini-css-extract-plugin
export default {"wrapper":"Copyright_wrapper__zBJOC","text-footer":"Copyright_text-footer__k5nge"};